import React from 'react';
import { NextPage, GetStaticPaths, GetStaticProps } from 'next';
import NextError from 'next/error';

import { EpisodeProps } from '~/types';
import Episode from '~/components/episode';
import { getEpisodes } from '~/lib/get-episodes';
import { getEpisode } from '~/lib/get-episode';
import { getParam } from '~/utils/get-param';

interface Props {
  episode?: EpisodeProps;
}

export const getStaticPaths: GetStaticPaths = async () => {
  const episodes = await getEpisodes();

  return {
    fallback: false,
    paths: episodes.map(episode => ({
      params: { id: String(episode.episodeNumber) },
    })),
  };
};

export const getStaticProps: GetStaticProps<Props> = async ({
  params = {},
}) => {
  if (!params.id) return { props: {} };
  const id = Number(getParam(params.id));
  const episode = await getEpisode(id);
  return { props: { episode }, unstable_revalidate: 86400 };
};

const EpisodePage: NextPage<Props> = ({ episode }) => {
  if (!episode) return <NextError statusCode={404} />;

  return (
    <Episode
      id={episode.id}
      key={episode.id}
      audio={episode.audio}
      date={episode.date}
      image={episode.image}
      imageAlt={episode.imageAlt}
      episodeNumber={episode.episodeNumber}
      episodeTitle={episode.episodeTitle}
      showNotes={episode.showNotes}
      shouldShowNotes
      link={episode.link}
    />
  );
};

export default EpisodePage;
